/**
 * Retrieves the name of the current route.
 * 
 * @param $route - The Vue Router object.
 * @returns The name of the current route.
 */
export const getNameRoute = ($route) => {
    return $route.name;
}